export const noteType = [
  { id: 'all', label: 'All' },
  { id: 'attendance_archived', label: 'Attendance Archived' },
  { id: 'attendance_deleted', label: 'Attendance Deleted' },
  { id: 'test_deleted', label: 'Test Deleted' },
  { id: 'test_archived', label: 'Test Archived' }
];

export const programTypeOptions = [
  { id: 'all', label: 'All' },
  { id: 'Permit Only', label: 'Permit Only' },
  { id: 'AFP', label: 'AFP' },
  { id: 'CDL Class B', label: 'CDL Class B' },
  { id: 'CDL Class A', label: 'CDL Class A' },
  { id: 'CDL Class A - Auto', label: 'CDL Class A - Auto' },
  { id: 'CDL Class A (AFP)', label: 'CDL Class A (AFP)' },
  { id: '40 Restriction Removal', label: '40 Restriction Removal' },
  { id: '40-Hour Refresher', label: '40-Hour Refresher' },
  { id: 'VPC Only', label: 'VPC Only' },
  { id: 'Hazmat Endorsement', label: 'Hazmat Endorsement' },
  { id: '40 Automatic restriction', label: '40 Automatic restriction' },
  { id: 'Yard Only', label: 'Yard Only' },
  { id: '80 Hour Refresher', label: '80 Hour Refresher' },
  { id: 'CDL Class A - CDL +', label: 'CDL Class A - CDL +' },
  { id: 'Refresher', label: 'Refresher' },
  { id: 'Class B to A Upgrade', label: 'Class B to A Upgrade' },
  { id: 'CDL Class A 240', label: 'CDL Class A 240' },
  { id: '160 Scoring', label: '160 Scoring' },
  { id: 'CDL B', label: 'CDL B' },
  { id: '20 Automatic restriction', label: '20 Automatic restriction' },
  { id: '40 Hour Refresher', label: '40 Hour Refresher' },
  { id: 'CDL Class A - WRG', label: 'CDL Class A - WRG' },
  { id: 'Hazmat', label: 'Hazmat' },
  { id: 'CDL Class A 200', label: 'CDL Class A 200' },
  { id: 'Yard Only CDL Class B', label: 'Yard Only CDL Class B' },
  { id: 'CDL Class A 400', label: 'CDL Class A 400' }
];
